import { FormEvent, useEffect, useState } from 'react'
import AuthContainer from '../../containers/auth/authContainer';
import * as S from './styles';
import { Input } from 'base/src/components/Input';
import { Button } from 'base/src/components/Button';
import { Icon } from '@iconify/react';
import { AutoFormData } from "domain/utils/FormUtils"
import { Login } from '../../store/login/actions/loginAction';
import { GetSistema } from 'base/src/store/sistema/action/sistemaAction'
import { IgnoreSideBar, IgnoreHeader, IgnoreAuth, IgnoreAuthRemove } from 'base/src/store/util/action/utilAction'
import { LoginByToken, ParceiroByUrl } from "base/src/store/authentication/action/authenticationAction"

import { LoginRequest } from '../../types/login/loginRequest';
import { RootStateAuth } from '../../store/authReducer';
import { useSearchParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import { RouteParamters } from 'base/src/utils/routeUtil';
import { Forms } from 'base/src/components/Form';
import { WdCarouselDotGroup, WDCarouselProvider, WDCarouselSlide, WDCarouselSlider } from 'base/src/components/Carrousel/index';
import { Switch } from 'base/src/components/Switch';
import AuthInfo from './components/AuthInfo';
import RecuperarSenha from './components/RecuperarSenha';
import assets from 'base/src/assets/assets';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

const connector = connectUtil(
  (state: RootStateAuth) => ({
    sistema: state.SistemaReducer.sistema,
    authenticado: state.AuthenticationReducer.authState,
    parceiroState: state.AuthenticationReducer.parceiroState,
  }),
  { Login, GetSistema, IgnoreSideBar, IgnoreHeader, LoginByToken, IgnoreAuth, IgnoreAuthRemove, ParceiroByUrl }
);

export interface AuthComponentProps extends PropsFromRedux<typeof connector> {}

function Auth(props: AuthComponentProps): JSX.Element {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const sistemaID = searchParams.get(RouteParamters.sistemaID);
  const token = searchParams.get(RouteParamters.token);
  const [showRecuperarSenha, setShowRecuperarSenha] = useState(false);

  function handleCloseRecuperarSenha (value: boolean) {
    return ()=>setShowRecuperarSenha(value);
  }

  function handleEnter (e: React.MouseEvent<HTMLElement>) {
    (e.target as HTMLElement).style.color = '#8c62d1'
  }

  function handleLeave (e: React.MouseEvent<HTMLElement>) {
    (e.target as HTMLElement).style.color = '#744cb4'
  }

  const authContainer = new AuthContainer(props, searchParams)

  function handleForm(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); 
    const formData = AutoFormData<LoginRequest>(event.currentTarget); 
    //LogFormData(formData);
    authContainer.Login(formData, () => {});
  }

  function handleCarouselSlide(index: number, titulo: string, descricao: string, infoImage: string) {
    return (
      <WDCarouselSlide index={index}>
     
        <AuthInfo
          titulo={titulo}
          descricao={descricao}
          infoImage={infoImage}
          imageHeight="400px"
        />
      </WDCarouselSlide>
    );
  }

  useEffect(() => {
    authContainer.GetParceiroByUrl();
    authContainer.GetSistema();
  }, []);

  useEffect(() => {
    if (token != null) {
      props.IgnoreAuthRemove(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    if (props.authenticado === true && props.sistema != null) {
      authContainer.Redirect(props.sistema);
      return;
    }
    if (props.authenticado === true) {
      if (sistemaID == null) {
        authContainer.RedirectToCentral();
      }
      return;
    }
  }, [props.authenticado, props.sistema]);

  return (
    <S.Container>
      <S.FormContainer>
        <Forms handleForm={handleForm}>
          <img src={props.parceiroState.UrlImagemLogo} style={{ width: 190, marginLeft: -10 }} />
          <S.ContainerTitle>
            <S.Title>Bem Vindo de volta!</S.Title>
            <S.Text>Entre para garantir acesso a seus dados e informações</S.Text>
          </S.ContainerTitle>
          <S.ContainerInput>
            <S.CustomLabel>
              <Icon icon="mdi:account" style={{ color: '#744cb4', fontSize: '16px' }} />
              Usuário
            </S.CustomLabel>
            <Input borderRadius='8px' form={true} name='Usuario' placeholder='Digite seu usuário' height='48px' borderColor='#d1d5db' iconName='mdi:account-outline' />
          </S.ContainerInput>
          <S.ContainerInput>
            <S.CustomLabel>
              <Icon icon="mdi:lock" style={{ color: '#744cb4', fontSize: '16px' }} />
              Sua senha
            </S.CustomLabel>
            <Input borderRadius='8px' type='password' form={true} name='Senha' placeholder='Digite sua senha' height='48px' borderColor='#d1d5db' iconName='mdi:lock-outline' />
          </S.ContainerInput>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <Switch name='ManterConectado' />
              <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Continuar Conectado</span>
            </div>
            <span style={{ color: '#744cb4', cursor: 'pointer', fontSize: '14px', fontWeight: '500', transition: 'color 200ms ease-in-out' }} onClick={handleCloseRecuperarSenha(true)} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>Esqueceu a senha?</span>
          </div>
          <Button style={{ borderRadius: '8px', height: '52px', fontSize: '18px', fontWeight: '600', marginTop: '8px', transition: 'all 200ms ease-in-out', boxShadow: '0 2px 8px rgba(116, 76, 180, 0.2)' }} type='submit' size='lg' variant='primary' full={true} iconName='mdi:login' iconPosition='left'>Acessar</Button>
           {/* <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Divider color={theme.colors.grey_text} orientation='horizontal' />
            <span>ou</span>
            <Divider color={theme.colors.grey_text} orientation='horizontal' />
          </div> */}
        </Forms>
      </S.FormContainer>

      <S.InfoContainer>
        <WDCarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={125}
          isIntrinsicHeight
          totalSlides={2}
          isPlaying
          interval={4000}
        >
          <WDCarouselSlider>
            {handleCarouselSlide(0, 'Uma forma simples de gerenciar suas campanhas', 'Nosso sistema para pagamentos de premiações em campanhas.', assets.imageExemplo2)}
            {handleCarouselSlide(1, 'Insira um texto', 'Insira uma descrição que mostra uma apara interessante sobre o produto', assets.imageExemplo1)}
          </WDCarouselSlider>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <WdCarouselDotGroup />
          </div>
        </WDCarouselProvider>
      </S.InfoContainer>
      <RecuperarSenha isOpen={showRecuperarSenha} onClose={handleCloseRecuperarSenha(false)} />
    </S.Container>
  );
}

export default connector(Auth);
